<template>
  <generic-modal :title="$t('template')" ref="generic_modal" :is_wide="true">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input
                type="text"
                class="input"
                v-model="meta.name"
                :placeholder="$t('name')"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field pt-5">
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_use_as_default"
              v-model="meta.use_as_default"
            />
            <label for="chk_use_as_default">{{
              $t("use this template as default")
            }}</label>
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t("template engine") }}</label>
        <div class="select">
          <select v-model="meta.template_engine">
            <option value="modul">Modul</option>
            <option value="handlebars">Handlebars</option>
          </select>
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t("message") }}</label>
        <vue-monaco-editor
          v-model:value="meta.message"
          theme="vs-dark"
          language="html"
          :options="{
            automaticLayout: true,
            formatOnType: true,
            formatOnPaste: true,
            tabSize: 2,
            scrollBeyondLastLine: false,
            folding: true,
            bracketPairColorization: true,
            autoClosingBrackets: 'always',
            autoIndent: 'full',
          }"
          style="height: 500px"
        />
        <!-- <div class="control">
          <textarea
            class="textarea"
            rows="2"
            v-model="meta.message"
            :placeholder="$t('your message here')"
          ></textarea>
        </div> -->
      </div>
      <div class="field">
        <label class="label">{{ $t("arguments") }}</label>
        <div
          class="field has-addons"
          v-for="(arg, aidx) in meta.arguments"
          :key="aidx"
        >
          <div class="control">
            <div class="button is-info">{{ arg.name }}</div>
          </div>
          <div class="control">
            <input
              class="input"
              type="text"
              :placeholder="$t('default value')"
              v-model="meta.arguments[aidx].default_value"
            />
          </div>
        </div>
      </div>

      <article class="message is-info">
        <div class="message-header">
          <p>{{ $t("some guidance info") }}</p>
        </div>
        <div class="message-body">
          <ul>
            <li>
              {{
                $t(
                  "in subject or message you can use variables defining them like this: $ {variable_name}"
                )
              }}
            </li>
          </ul>
        </div>
      </article>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
} from "@/utils";
import { cloneDeep } from "lodash";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import { VueMonacoEditor } from "@guolao/vue-monaco-editor";

export default {
  name: "TemplateModal",
  components: { GenericModal, GenericDropdown, VueMonacoEditor },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
      template_uuid: undefined,
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name || !v.meta.message;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(template_uuid) {
      let v = this;
      v.set_initial_state();
      if (template_uuid) {
        get("/landing/template", { uuid: template_uuid })
          .then((response) => {
            v.template_uuid = template_uuid;
            let meta = {
              name: response.name,
              message: response.settings.message,
              template_engine: response.settings.template_engine,
              use_as_default: response.settings.use_as_default,
            };
            v.meta = meta;
            setTimeout(() => {
              v.meta.arguments = response.settings.arguments;
            }, 200);
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;

      if (v.template_uuid) {
        let meta = { ...v.meta };
        meta.uuid = v.template_uuid;
        post("/landing/template", meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else {
        put("/landing/template", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        message: "",
        template_engine: "",
        arguments: [],
      };
      v.template_uuid = undefined;
      v.error = "";
    },
    calculate_variables() {
      let v = this;
      let argums = [];

      if (v.meta.message) {
        let regex = /\$\{[a-zA-Z_][a-zA-Z_0-9]*\}/gi;
        let __args = v.meta.message.match(regex);
        if (__args) {
          argums = argums.concat(
            __args.map((v) => {
              return { name: v, default_value: "" };
            })
          );
        }
      }

      let args_ = [];
      for (let index = 0; index < argums.length; index++) {
        const __arg = argums[index];
        let trgt = args_.find((_arg) => {
          return _arg.name == __arg.name;
        });
        if (!trgt) {
          args_.push(__arg);
        }
      }

      if (!v.meta.arguments) {
        v.meta.arguments = [];
      }

      let filtered = v.meta.arguments.filter((arg) => {
        return args_.find((_arg) => {
          return _arg.name == arg.name;
        });
      });
      args_ = args_.map((arg) => {
        let trgt = filtered.find((_arg) => {
          return _arg.name == arg.name;
        });
        if (trgt) {
          return trgt;
        } else {
          return arg;
        }
      });

      v.meta.arguments = cloneDeep(args_);
    },
  },
  mounted() {},
  watch: {
    "meta.message": function () {
      let v = this;
      v.calculate_variables();
    },
  },
};
</script>
<style></style>
